import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import type { FermentationInvestigationId } from "@brewbase/db/types";
import { InvestigationPage } from "@/features/fermentation-investigation/investigation-page";

export const Route = createFileRoute("/fermentations/investigations/$investigation_id")({
  component: RouteComponent,
  params: z.object({ investigation_id: z.coerce.number() }),
  head: ({ params }) => ({
    meta: [{ title: `BrewBase - Investigation ${params.investigation_id}` }],
  }),
});

function RouteComponent() {
  const { investigation_id } = Route.useParams();
  return <InvestigationPage investigationId={investigation_id as FermentationInvestigationId} />;
}
